<template>
  <div class="custom-swiper" @mouseenter="showDesc = true" @mouseleave="showDesc = false">
    <Transition name="fade">
      <div class="swiper-desc" v-if="showDesc">
        <div class="desc-name">{{ currentText.name }}</div>
        <div class="flex-align-center">
          <span class="desc-content multiple-ellipsis">{{ currentText.content }}</span>
          <swiper-navigation :hidden-click="true" :total="swiperList.length" :current-index="currentText.index" />
        </div>
      </div>
    </Transition>

    <img class="dynamic-left-vector vector" src="@/assets/images/left.png" alt="" @click="swiperChange('prev')" />
    <img class="dynamic-right-vector vector" src="@/assets/images/right.png" alt="" @click="swiperChange('next')" />

    <swiper
        :modules="modules"
        :loop="true"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(item, index) in swiperList" :key="index" :virtual-index="index">
        <a v-if="item.link" :href="item.link" target="_blank">
          <img :src="item.image" alt="" />
        </a>
        <img v-else :src="item.image" alt="" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import SwiperNavigation from '@/components/SwiperNavigation/index'
import { Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper.scss'
import 'swiper/modules/pagination/pagination.scss'
import { ref, defineProps, onMounted } from 'vue'

const modules = [Pagination, Autoplay, EffectFade]

const props = defineProps({
  swiperList: {
    type: Array,
    default: () => []
  }
})

let swiperRef = null
const showDesc = ref(false)

const currentText = ref({})

onMounted(() => {
  currentText.value = props.swiperList[0]
})

function onSwiper (swiper) {
  swiperRef = swiper
}

function onSlideChange (data) {
  currentText.value = props.swiperList[data.realIndex]
}

function swiperChange (type) {
  if (type === 'next') {
    swiperRef.slideNext()
  } else {
    swiperRef.slidePrev()
  }
}
</script>

<style lang="scss" scoped>
.custom-swiper {
  overflow: hidden;
  position: relative;
}

.swiper-slide img {
  width: 100%;
}

.vector {
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);

  &.dynamic-left-vector {
    left: 48px;
  }

  &.dynamic-right-vector {
    right: 48px;
  }
}

.swiper-desc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  height: 176px;
  box-sizing: border-box;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
  padding: 0 61px;
  color: white;
  border-radius: 0 0 10px 10px;

  .desc-name {
    font-size: 36px;
    font-weight: 600;
    line-height: 52px;
    font-family: 'NotoSerifSC', system-ui;
  }

  .desc-content {
    flex: 1;
    font-size: 24px;
    font-weight: 400;
    line-height: 35px;
    color: rgba(255, 255, 255, 0.6);
    margin-right: 5px;
    -webkit-line-clamp: 1;
  }
}
</style>
